import { useRouter } from "vue-router"
import { unref, computed } from "vue"

export const useButton = (to, href, tag, loading, emit) => {
    const router = useRouter()

    const component = computed(() => {
        if (unref(to)) return "router-link"
        if (unref(href)) return "a"
        if (unref(tag)) return unref(tag)
        return "button"
    })

    const resolvedRoute = computed(() => {
        if (!unref(to)) return

        const resolution = router.resolve(unref(to))
        if (!resolution || resolution.matched.length === 0) {
            console.warn(`[useButton] Route "${unref(to)}" not found.`)
            return
        }
        return resolution.href
    })

    const clickEvent = event => {
        if (unref(loading)) {
            event.preventDefault()
            return
        }
        emit("click", event)
    }

    return { component, resolvedRoute, clickEvent }
}
